import { createSlice } from "@reduxjs/toolkit";
import { STORAGE_KEYS } from "../../constants/keys";
import { IUser } from "../../types/IUser.interface";
interface Init {
  User: IUser | null;
}
const initialState: Init = {
  User: {
    _id: "",
    name: "",
    city: "",
    postalCode: "",
    email: "",
    isSocialLogin: false,
    customerId: "",
    centerId: "",
    contactNumber: "",
    provider: "",
    isDeactivated: false,
    isProfileCompleted: false,
    isVerified: false,
    createdOn: "",
    __v: 0,
    iat: 0,
    exp: 0,
  }
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUser: (state, action) => {
      state.User = action.payload;
    },
    removeUser: (state) => {
      // DEVICE_TRUST_TOKEN is a device-level credential meant to outlive any
      // one session (trusted for 30 days regardless of "remember me") — it's
      // cleared only via an explicit revoke (Security page) or expiry, never
      // as part of clearing a session's accToken/rfToken/user/role here.
      Object.values(STORAGE_KEYS)
        .filter((key) => key !== STORAGE_KEYS.DEVICE_TRUST_TOKEN)
        .forEach((key) => localStorage.removeItem(key))
      state.User = null;
    },
    loadUser: (state) => {
      const user = JSON.parse(localStorage.getItem(STORAGE_KEYS.USER)!);
      if (user) {
        state.User = user;
      }
    },
  },
});

export const { setAuthUser, removeUser, loadUser } = authSlice.actions;

export default authSlice.reducer;
